import React from 'react';
import PropTypes from 'prop-types';
import ContainerWrapper from '../../styled components/ContainerWrapper';
import {
  SubHeaderBodyContent,
  SubHeaderContainer,
  SubHeaderMainContent
} from './WidgetPageSubHeader.style';

const WidgetPageSubHeader = ({ renderMainContent, renderBodyContent = null }) => (
  <SubHeaderContainer>
    <ContainerWrapper $paddingY={8}>
      <SubHeaderMainContent>{renderMainContent()}</SubHeaderMainContent>
      {renderBodyContent && (
        <SubHeaderBodyContent>{renderBodyContent()}</SubHeaderBodyContent>
      )}
    </ContainerWrapper>
  </SubHeaderContainer>
);

WidgetPageSubHeader.propTypes = {
  renderMainContent: PropTypes.func.isRequired,
  renderBodyContent: PropTypes.func,
  forwardedRef: PropTypes.shape({ current: PropTypes.elementType })
};

export default WidgetPageSubHeader;
